import { lazy, Suspense } from 'react'
import Loader from '../custom/loader/main';

const Main = lazy(() => import('../components/approval/approveResults/main'));

const ApproveResults = () => {
  return (
    <Suspense fallback={<Loader/>}>
      <Main/>
    </Suspense>
  )
}

export default ApproveResults;